/** Meta pixel "pixel special ed ready" (stockdigital.com, connected to the stockdigital 2 ad account).
 *  PageView on load, ViewContent when the offer section is seen, InitiateCheckout ONLY on the offer button. */
export const META_PIXEL_ID = '2288130925308134';
